// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import { useTitle } from "react-use"
import type { RouteDefinition } from "app/routing/paths"

type OwnProps = {
  route: RouteDefinition,
}

export type Props = OwnProps

const RouteWrapper = ({
  route: {
    main: Main,
    sidebar: Sidebar,
    title,
  },
}: Props): React.ReactElement<Props> | null => {
  useTitle(`${title} | WiseTime Console`)
  return (
    <React.Fragment>
      {Sidebar && <Sidebar />}
      {Main && <Main />}
    </React.Fragment>
  )
}

export default RouteWrapper

